import { createContext } from "react";

const SetNotificationContext = createContext((_, __) => {});

export default SetNotificationContext;